import React from 'react'
import { Tooltip, Typography } from '@material-ui/core'
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined'

import useStyles from './styles'

export function HelpTooltipButton({ text, placement = 'bottom-end', size = '20px' }) {
  const styles = useStyles()
  return (
    <Tooltip
      arrow
      disableFocusListener
      disableTouchListener
      title={<Typography className={styles.tooltipText}>{text}</Typography>}
      placement={placement}
    >
      <HelpOutlineOutlinedIcon className={styles.tooltipIcon} style={{ fontSize: size }} />
    </Tooltip>
  )
}
